module.exports = "\n<form @submit.prevent=\"postForm\" class=\"newsletter__form\">\n  <slot></slot>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegistrationForm.vue
// module id = 89
// module chunks = 0